import React, { useState } from 'react';
import { Box, Image } from '@chakra-ui/react';
import { ImageSliderProps } from '../../interfaces/components';
import Slider, { CustomArrowProps } from 'react-slick';
import { RightArrow } from '../../Icons/RightArrow';
import { LeftArrow } from '../../Icons/LeftArrow';

const BackArrow = (props: CustomArrowProps) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <LeftArrow stroke="#CCCCCC" _hover={{ stroke: 'black' }} />
    </div>
  );
};

const NextArrow = (props: CustomArrowProps) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <RightArrow stroke="#CCCCCC" _hover={{ stroke: 'black' }} />
    </div>
  );
};

const ImageSlider = ({ highlightImage, images, setHighLightImage }: ImageSliderProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [slider, setSlider] = useState<any>();

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <BackArrow />,
    beforeChange: (oldIndex: number, newIndex: number) => {
      if (highlightImage === images[oldIndex]) {
        setHighLightImage(images[newIndex]);
      }
    },
  };

  return (
    <Box
      width={['100%', '100%', '420px', '500px', '550px']}
      maxH={['unset', 'unset', '450px', '450px', '500px']}
      display="flex"
      flexDirection={['column', 'column', 'column', 'column', 'column']}
      position="relative"
    >
      <Box
        width={['auto', '100%', '380px', '450px', '500px']}
        h={['400px', '500px', '360px', '400px', '450px']}
        marginLeft={['0px', '0px', '25px', '25px', '25px']}
        textAlign="center"
      >
        <Slider ref={(slider) => setSlider(slider)} {...settings}>
          {images?.map((image: string, index: number) => (
            <Image
              loading="lazy"
              key={index}
              width={['auto', '100%', '400px', '550px', '600px']}
              h={['100%', '100%', '340px', '400px', '450px']}
              objectFit={['contain', 'contain', 'contain', 'contain', 'contain']}
              src={image}
            />
          ))}
        </Slider>
      </Box>
      <Box
        height={['30px', '30px', '30px', '50px', '50px']}
        overflowY={['hidden', 'hidden', 'hidden', 'hidden', 'hidden']}
        overflowX={['auto', 'auto', 'auto', 'auto', 'auto']}
        width={['100%', '100%', '100%', '100%', '100%']}
        display="flex"
        flexDirection={['row', 'row', 'row', 'row', 'row']}
        alignItems="center"
        justifyContent="center"
      >
        {images?.map((image: string, index: number) => (
          <Box
            flex={['0 0 auto', '0 0 auto', 'unset', 'unset', 'unset']}
            key={index}
            width={['30px', '30px', '30px', '40px', '40px']}
            height={['30px', '30px', '30px', '40px', '40px']}
            margin={['0px 5px 0px 0px', '5px', '5px', '5px', '5px']}
          >
            <Image
              loading="lazy"
              cursor="pointer"
              width="100%"
              height="100%"
              objectFit="contain"
              src={image}
              alt="Product Image"
              onClick={() => {
                setHighLightImage(image);
                slider.slickGoTo(index);
              }}
              border="2px solid #ccc"
              opacity={image === highlightImage ? '0.4' : '1'}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ImageSlider;
